import { Template3 } from "./ProcessesTemplate_tree";

export const ProcessTemplates = [
  {
    name: "S/4HANA PROCESSES",
    image: "/images/process-templates/sap.png",
    processes: Template3
  }
];
